import type { Translation } from '@nordhealth/components'
import i18next from 'i18next'
import { useSupportedLocales } from '@/composables/i18next.js'

export const useNordTranslation = (locale: string) => {
  const { supportedLocalesByCode } = useSupportedLocales()

  // we want to fix the t function, so that it always matches the given locale,
  // allowing us to control when the translations are switched over
  const tNordComponents = i18next.getFixedT(
    locale,
    'application',
    'common.nordComponents',
  )

  const translation: Translation = {
    $lang: locale,
    $name: supportedLocalesByCode[locale].name,
    $dir: i18next.dir(locale),

    'nord-command-menu': {
      instructions: tNordComponents('commandMenu.instructions'),
      inputLabel: tNordComponents('commandMenu.inputLabel'),
      footerArrowKeys: tNordComponents('commandMenu.footerArrowKeys'),
      footerEnterKey: tNordComponents('commandMenu.footerEnterKey'),
      footerEscapeKey: tNordComponents('commandMenu.footerEscapeKey'),
      footerBackspaceKey: tNordComponents('commandMenu.footerBackspaceKey'),
      noResults: (searchTerm: string) =>
        tNordComponents('commandMenu.noResults', { searchTerm }),
      tip: tNordComponents('commandMenu.tip'),
      placeholder: tNordComponents('commandMenu.placeholder'),
    },

    'nord-calendar': {
      prevMonthLabel: tNordComponents('calendar.prevMonthLabel'),
      nextMonthLabel: tNordComponents('calendar.nextMonthLabel'),
      monthSelectLabel: tNordComponents('calendar.monthSelectLabel'),
      yearSelectLabel: tNordComponents('calendar.yearSelectLabel'),
    },

    'nord-date-picker': {
      modalHeading: tNordComponents('datePicker.modalHeading'),
      closeLabel: tNordComponents('datePicker.closeLabel'),
      buttonLabel: tNordComponents('datePicker.buttonLabel'),
      selectedDateMessage: tNordComponents('datePicker.selectedDateMessage'),
      dateOutOfMinBound: (minDate: string) =>
        tNordComponents('datePicker.dateOutOfMinBound', { minDate }),
      dateOutOfMaxBound: (maxDate: string) =>
        tNordComponents('datePicker.dateOutOfMaxBound', { maxDate }),
    },

    'nord-modal': {
      closeLabel: tNordComponents('modal.closeLabel'),
    },

    'nord-nav-toggle': {
      label: tNordComponents('navToggle.label'),
    },

    'nord-textarea': {
      remainingCharacters: (remainder: number) =>
        tNordComponents('commandMenu.noResults', { remainder }),
    },

    'nord-notification': {
      dismissLabel: tNordComponents('notification.dismissLabel'),
    },

    'nord-message': {
      unreadLabel: tNordComponents('message.unreadLabel'),
    },

    'nord-tag': {
      removeLabel: tNordComponents('tag.removeLabel'),
    },
  }

  return translation
}
